export default "__VITE_ASSET__jZmadSFo__"